import { createSelectors } from '@src/stores/create-selectors';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  // whether the MUI mobile navigation drawer is open
  open: boolean;
  actions: Actions;
};

type Actions = {
  // set open = true
  openDrawer: () => void;
  // set open = false
  closeDrawer: () => void;
  // toggle open state
  toggleDrawer: () => void;
  // explicitly set open to a value
  setOpen: (open: boolean) => void;
};

/**
 * Zustand store for the MOBILE navigation drawer state.
 * Mobile default: closed (open: false)
 */
const useMobileNavigationStoreBase = create<State>()(
  devtools(
    (set, get) => ({
      open: false,
      actions: {
        openDrawer: () => set({ open: true }, false, 'openDrawer'),
        closeDrawer: () => set({ open: false }, false, 'closeDrawer'),
        toggleDrawer: () => set({ open: !get().open }, false, 'toggleDrawer'),
        setOpen: (open) => set({ open }, false, 'setOpen'),
      },
    }),
    { name: 'useMobileNavigationState' },
  ),
);

export const useMobileNavigationStore = createSelectors(
  useMobileNavigationStoreBase,
);
